<script>

  import { onMount, setContext } from 'svelte';
  import { key } from './map.js';

  setContext(key, {
    getMap: () => map,
    getInfowindow: () => infowindow,
    getOverlay: () => overlay,
  });

  let map;
  let infowindow;
  let overlay;

  let mapId = "12221b969f0eaeba";
  let container;
  let zoom = 10;
  let center = { lat: 41.874749, lng:  -87.630117 };
  let disableDefaultUI = true;
  let gestureHandling = 'auto';
  let zoomControl = true;
  let clickableIcons = false;

  onMount(async () => {
    const options = {
        mapId,
        zoom,
        center,
        disableDefaultUI,
        gestureHandling,
        zoomControl,
        clickableIcons
    };

    map = new google.maps.Map(container, options);

    infowindow = new google.maps.InfoWindow();

    overlay = new google.maps.Rectangle({
      strokeColor: "#FF5544",
      strokeOpacity: 0,
      strokeWeight: 0,
      fillColor: "#FF5544",
      fillOpacity: 0.75,
      map: null,
      bounds: {
        north: 90,
        south: -90,
        east: 180,
        west: -180,
      },
    });

    overlay.addListener("click", () => {
      infowindow.setMap(null);
      overlay.setMap(null);
    });

    infowindow.addListener('closeclick',function(){
      overlay.setMap(null);
    });

  });
</script>

<div class="map" bind:this={container}>
  {#if map}
    <slot></slot>
  {/if}
</div>
